<template>
	<div class="homes">
		<van-tabs v-model="active" @click="onClick">
		  <van-tab :title="item.name" v-for='(item,index) in list' :key='index'>
			  <slot :name="item.type"></slot>
		  </van-tab>
		</van-tabs>
	</div>
</template>

<script>
	export default {
		props:['list'],
		data() {
			return {
				active:0,
				
			}
		},
		methods:{
			onClick(value){
				console.log(value)
				this.$emit("tabChange",value)
			}
		}
	}
</script>

<style lang="less" scoped>
	.homes {
		// background: #f7f7f7;
		// padding: 20px;
		border-top: 1px solid #ccc;
		// position: fixed;
		// top:0;
		// left:0;
		width: 100%;
		height: 100px;
		
	}
</style>
